export default "__VITE_ASSET__CizkmUiH__"